import { render, staticRenderFns } from "./Hair18.vue?vue&type=template&id=24b8f35d&"
import script from "./Hair18.vue?vue&type=script&lang=js&"
export * from "./Hair18.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports